<template>
  <div class="flex items-center justify-between home-page-header">
    <div class="flex items-center home-header-left cursor-pointer mr-4" @click="router.push('/')">
      <img src="@/assets/img/logo.png" width="240" />
    </div>

    <div class="flex-1" ref="titleElement">

      <div class="text-center">
        <el-link type="primary" :underline="false" @click="onOpenInvite">
          <span v-if="!showShortTitle">📢 功能上新：试试「一键定制」自己想要的专属课程</span>
          <span v-if="showShortTitle">📢「一键定制」专属课程</span>
        </el-link>
      </div>
    </div>

    <div class="home-header-right">
      <el-button v-if="loginStatus" size="large" @click="loginOut" class="logout-btn">
        退出登录
      </el-button>
      <el-button v-else type="primary" size="large" @click="login">
        注册/登录
      </el-button>
    </div>
  </div>

  <!-- 注册弹窗 -->
  <el-dialog v-model="registerDialogVisible" align-center width="500" modal-class="login-modal"
    :before-close="handleClose">
    <div class="login-pop-wrap">
      <div class="login-pop-title font-bold">注册/登录</div>
      <el-tabs v-model="loginTab" class="login-tabs">
        <el-tab-pane label="短信登录" name="sms">
          <el-form ref="ruleFormRef" :model="registerForm" :rules="rules" label-width="auto">
            <el-form-item prop="phone">
              <div class="">我的手机</div>
              <el-input size="large" v-model.trim="registerForm.phone" clearable placeholder="请输入电话">
                <template #prepend>
                  <el-button :icon="PhoneFilled" />
                  <span class="pl-2.5">+86</span>
                </template>
              </el-input>
            </el-form-item>

            <el-form-item prop="vcode">
              <div class="">我的验证码</div>
              <el-input size="large" v-model.trim="registerForm.vcode" maxlength="6" clearable placeholder="请输入验证码"
                class="verifyCode">
                <template #append>
                  <el-button class="get-verify-code-btn" :disabled="getCodeStatus" type="primary" @click="getCode">
                    {{ getCodeStatusWords }}
                  </el-button>
                </template>
              </el-input>
            </el-form-item>

            <el-button class="mt-2.5 w-full inputBox" type="primary" size="large" @click="subRegister(ruleFormRef)"
              :loading="false">
              <span>注册/登录</span>
            </el-button>

            <div class="mt-4">
              <el-checkbox v-model="registerForm.agreementChecked">
                <span class="flex items-center">
                  <span>登录注册即表示同意</span>
                  <text class="cursor-pointer word-color mx-1" type="primary" @click="openLink(1)">用户协议</text>
                  <span>和</span>
                  <text class="cursor-pointer word-color mx-1" type="primary" @click="openLink(2)">隐私政策</text>
                </span>
              </el-checkbox>
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="账号登录" name="account">
          <el-form ref="accountFormRef" :model="accountForm" :rules="accountRules" label-width="auto">
            <el-form-item prop="account">
              <div class="">我的账号</div>
              <el-input size="large" v-model.trim="accountForm.account" clearable placeholder="请输入账号" />
            </el-form-item>
            <el-form-item prop="password">
              <div class="">我的密码</div>
              <el-input size="large" v-model.trim="accountForm.password" clearable placeholder="请输入密码"
                type="password" />
            </el-form-item>
            <el-button class="mt-2.5 w-full inputBox" type="primary" size="large"
              @click="subAccountLogin(accountFormRef)" :loading="false">
              <span>注册/登录</span>
            </el-button>
            <div class="mt-4">
              <el-checkbox v-model="accountForm.agreementChecked">
                <span class="flex items-center">
                  <span>登录注册即表示同意</span>
                  <text class="cursor-pointer word-color mx-1" type="primary" @click="openLink(1)">用户协议</text>
                  <span>和</span>
                  <text class="cursor-pointer word-color mx-1" type="primary" @click="openLink(2)">隐私政策</text>
                </span>
              </el-checkbox>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>

  <el-dialog title="邀注册，得钻石" show-close v-model="inviteDialogVisible" modal-class="distribution-wrap">
    <div class="px-8 pt-16 pb-20 flex flex-col h-full">
      <div class="flex-1 flex flex-col justify-around mb-10">
        <div class="text-[24px] font-bold">首月限时特惠 !</div>

        <div>
          <div class="text-[20px] mb-1">
            每邀请
            <span class="text-[24px] font-black">1</span>
            名好友注册，可获得钻石返充，
          </div>
          <div class="text-[20px]">
            最近一次消费金额 x <span class="text-[24px] font-black">5%</span> =
            返充钻石数
          </div>
        </div>

        <div>
          <div class="text-[16px] mb-1">
            钻石余额可直接抵扣后续消费，1钻石 = 1元人民币
          </div>
          <div class="text-[14px] mb-1">钻石余额可前往“个人中心”查看</div>
        </div>
      </div>
      <div class="h-[40px]">
        <el-button type="primary" @click="getRefLink">获取专属邀请链接</el-button>
      </div>
    </div>
  </el-dialog>

  <CustomCourseModal v-model="showCustomCourseModal" @create-course="handleCustomCourseCreated"
    :call-back="handleCustomCourseCallback" />

  <CourseGenerationModal v-model="showCourseGenerationModal" :course-topic="selectedCourseTopic"
    @complete="handleCourseGenerationComplete" :call-back="handleCourseGenerationCallback"
    :arrange-course-callback="arrangeCourseCallback" />
</template>

<script setup lang="ts">
import CustomCourseModal from '../../pages/diagnosis/CustomCourseModal.vue';
import CourseGenerationModal from '../../pages/diagnosis/CourseGenerationModal.vue';

import { useRouter } from "vue-router";
import { onUnmounted, reactive, watch } from "vue";
import {
  setCookie,
  clearAllStorage,
  removeCookie,
} from "@/utils";
import type { FormInstance, FormRules } from "element-plus";
import { PhoneFilled } from "@element-plus/icons-vue";
import { onBeforeUnmount, onMounted, ref } from "vue";
import useAIChatStore from "@/store/aiChat";
import useUserStore from "@/store/user";
import { storeToRefs } from "pinia";
import { ElMessage } from "element-plus";
import { sendVerificationCode, signIn, signInUp } from "@/api/modules/user";
import { getReferralLink, getUserLastModel } from "@/api/modules/chat";
import pdf1 from "@/assets/doc/隐私政策.pdf";
import pdf2 from "@/assets/doc/用户协议.pdf";
import { getAllModels } from "@/api/modules/chat";
const { setLoginStatus } = useUserStore();
const { setCurrentUseModel } = useAIChatStore();

const router = useRouter();

const { loginStatus, showSelectStatus } = storeToRefs(useUserStore());
const { currentUseModel } = storeToRefs(useAIChatStore());

interface RuleForm {
  phone: string;
  vcode: string;
  referral: string;
  agreementChecked: boolean;
}
interface ModelListDTO {
  model_name: string;
  desc?: any;
  disabled: boolean;
}

const currentModel = ref(currentUseModel);
const ruleFormRef = ref<FormInstance>();
const modelList = ref<ModelListDTO[]>([]);
const showSelectModel = ref<boolean>(true);

const titleElement = ref();
const showShortTitle = ref(false);
const selectedCourseTopic = ref('');


const showCustomCourseModal = ref(false);
const showCourseGenerationModal = ref(false);

// 处理自定义课程创建
const handleCustomCourseCreated = (topic: string) => {
  selectedCourseTopic.value = topic;
  showCustomCourseModal.value = false;
  showCourseGenerationModal.value = true;
};

// 处理自定义课程弹窗的回调
const handleCustomCourseCallback = () => {
  console.log('自定义课程流程完成');
  showCustomCourseModal.value = false;
};


// 处理课程生成完成
const handleCourseGenerationComplete = (courseData: any) => {
  showCourseGenerationModal.value = false;
  ElMessage.success('自定义课程创建成功！');
};


// 处理课程生成弹窗的回调
const handleCourseGenerationCallback = () => {
  showCourseGenerationModal.value = false;
};


const arrangeCourseCallback = () => {
  setTimeout(() => {
    router.push('/plan')
  }, 500)
}


let resizeObserver: ResizeObserver | null = null;

onMounted(() => {
  // 创建一个ResizeObserver实例
  resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const titleElementWidth = entry?.contentRect?.width;

      if (titleElementWidth < 768) {
        showShortTitle.value = true;
      } else {
        showShortTitle.value = false;
      }
    });
  });

  if (titleElement.value) {
    resizeObserver.observe(titleElement.value);
  }
});

onUnmounted(() => {
  if (resizeObserver) {
    resizeObserver.disconnect();
  }
});

const validatePhoneNum = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("手机号不能为空"));
  } else {
    const phoneNumRegex = /^1(?![4])\d{10}$/;
    if (!phoneNumRegex.test(value)) {
      callback(new Error("请输入正确的手机号"));
    }
    callback();
  }
};

const rules = reactive<FormRules<RuleForm>>({
  phone: [
    {
      required: true,
      validator: validatePhoneNum,
      trigger: "change",
    },
  ],
  vcode: [
    { required: true, message: "请输入验证码", trigger: "change" },
    { max: 6, message: "请输入6位长度验证码", trigger: "change" },
  ],
});

const registerForm = reactive<RuleForm>({
  phone: "",
  vcode: "",
  referral: "",
  agreementChecked: false,
});

const registerDialogVisible = ref<boolean>(false);
const inviteDialogVisible = ref<boolean>(false);

const handleClose = () => {
  registerForm.phone = "";
  registerForm.referral = "";
  registerForm.vcode = "";
  registerForm.agreementChecked = false;
  registerDialogVisible.value = false;

  inviteDialogVisible.value = false;
};

const subscribeMember = () => {
  window.open("/recharge");
  // router.push("/recharge");
  // 判断登录完成之后再进行上面跳转
};

const openLink = (link: number) => {
  if (link === 1) {
    window.open(pdf1, "_blank");
  } else {
    window.open(pdf2, "_blank");
  }
};

const getCodeStatus = ref<any>(false);
const getCodeStatusWords = ref<any>("获取短信验证码");
const count = ref<any>(60);

const updateCountdown = () => {
  if (count.value > 0) {
    count.value--;
    getCodeStatusWords.value = count.value + "S 后重新获取";
    setTimeout(updateCountdown, 1000); // 每秒更新一次
  } else {
    getCodeStatusWords.value = "重新获取";
    getCodeStatus.value = false;
  }
};
// 获取验证码
const getCode = () => {
  if (getCodeStatus.value) return;
  if (registerForm.phone === "") {
    return ElMessage.warning("手机号不能为空");
  } else {
    const phoneNumRegex = /^1(?![4])\d{10}$/;
    if (!phoneNumRegex.test(registerForm.phone)) {
      return ElMessage.warning("请输入正确的手机号");
    }
  }
  if (!registerForm.agreementChecked) {
    return ElMessage.warning("请选勾选用户协议和隐私政策！");
  }

  count.value = 60;
  getCodeStatus.value = true;
  updateCountdown();
  sendVerificationCode({
    phone: registerForm.phone,
  }).then(() => {
    console.log("登录成功");
  });
};

const goUserAgreement = () => {
  // router.push('/personal') // 用户协议
};

const emit = defineEmits(["btnClickCallBack"]);

const login = () => {
  registerDialogVisible.value = true;
  emit("btnClickCallBack");
};

const loginOut = () => {
  clearAllStorage();
  setLoginStatus(false);
  removeCookie("Authorization");
  removeCookie("refreshToken");
  router.replace("/");
};

const subRegister = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;

  if (!registerForm.agreementChecked) {
    return ElMessage.warning("请选勾选用户协议和隐私政策！");
  }

  if (registerForm.phone && registerForm.vcode) {
    await formEl.validate((valid, fields) => {
      const params = new URLSearchParams(window.location.search);
      let referral = params.get("referral");
      if (referral) {
        registerForm.referral = referral || "";
      }

      if (valid) {
        signInUp(registerForm).then((res) => {
          if (res.data && res.data.access_token) {
            setCookie(
              "Authorization",
              res.data.token_type + " " + res.data.access_token
            );
            setLoginStatus(true);
            setCookie("refreshToken", res.data.refresh_token);
            registerDialogVisible.value = false;

            getUserLastModel().then(({ data }) => {
              if (data.model) {
                router.replace("/chat");
              } else {
                router.replace("/play-ground");
              }
            });
          }
        });
      } else {
        console.log("error submit!", fields);
      }
    });
  } else {
    ElMessage.warning("请输入手机号和验证码");
  }
};

const onkeypress = ({ code }: { code: string }) => {
  if (code === "Enter") {
    subRegister(ruleFormRef.value);
  }
};

const initModelList = () => {
  getAllModels().then((res) => {
    if (res?.data?.text2text.length > 0) {
      const allModel = [...res?.data?.text2text, ...res?.data?.image2text];

      const uniqueAllModel = allModel.filter((obj, index) => {
        return (
          allModel.findIndex((item) => item.model_name === obj.model_name) ===
          index
        );
      });

      if (uniqueAllModel?.length) {
        modelList.value = uniqueAllModel;
      }

      getUserLastModel().then(({ data }) => {
        if (data.model) {
          setCurrentUseModel(data.model);
        }
      });
    }
  });
};

const handleChangeModel = (value: string) => {
  setCurrentUseModel(value);
};

const onOpenInvite = () => {
  // inviteDialogVisible.value = true;
  showCustomCourseModal.value = true

};

const goToPlan = () => {
  router.push('/plan')
}

const getRefLink = async () => {
  const { data } = await getReferralLink();
  if (data) {
    const tempElement = document.createElement("input");
    tempElement.value = data.referral_link;
    document.body.appendChild(tempElement);
    tempElement.select();
    setTimeout(function () {
      document.execCommand("copy");
      document.body.removeChild(tempElement);
      ElMessage.success("复制成功");
    }, 0);
  }
};

const loginTab = ref("sms");

// 账号登录表单
const accountFormRef = ref<FormInstance>();
const accountForm = reactive({
  account: "",
  password: "",
  agreementChecked: false,
});
const accountRules = reactive<FormRules<any>>({
  account: [
    { required: true, message: "请输入账号", trigger: "change" },
  ],
  password: [
    { required: true, message: "请输入密码", trigger: "change" },
  ],
});

const subAccountLogin = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  if (!accountForm.agreementChecked) {
    return ElMessage.warning("请选勾选用户协议和隐私政策！");
  }
  if (accountForm.account && accountForm.password) {
    await formEl.validate((valid, fields) => {
      if (valid) {
        signIn({
          username: accountForm.account,
          password: accountForm.password,
          grant_type: 'password',
        }).then((res) => {

          if (res.data && res.data.access_token) {
            setCookie(
              "Authorization",
              res.data.token_type + " " + res.data.access_token
            );
            setLoginStatus(true);
            setCookie("refreshToken", res.data.refresh_token);
            registerDialogVisible.value = false;

            getUserLastModel().then(({ data }) => {
              if (data.model) {
                router.replace("/chat");
              } else {
                router.replace("/play-ground");
              }
            });
          }
        })
      } else {
        console.log("error submit!", fields);
      }
    });
  } else {
    ElMessage.warning("请输入账号和密码");
  }
};

onMounted(async () => {
  // const { loadAll } = await getuser();
  // restaurants.value = loadAll;
  window.document.addEventListener("keypress", onkeypress);

  // 监听打开注册弹窗事件
  window.addEventListener('openRegisterModal', () => {
    registerDialogVisible.value = true;
  });

  if (loginStatus.value && showSelectStatus.value) {
    initModelList();
  }

  const params = new URLSearchParams(window.location.search);
  let referral = params.get("referral"); // John

  if (referral) {
    login();
  }
});

onBeforeUnmount(() => {
  window.document.removeEventListener("keypress", onkeypress);
  // 移除事件监听
  window.removeEventListener('openRegisterModal', () => {
    registerDialogVisible.value = true;
  });
});

watch(
  () => router.currentRoute.value.name,
  (newRouterName: any) => {
    const pages = ["HomePage", "Recharge", "RechargeWxPay", "RechargeMore"];
    if (pages.includes(newRouterName)) {
      showSelectModel.value = false;
    } else {
      showSelectModel.value = true;
    }
  },
  { immediate: true }
);
</script>

<style lang="scss">
.home-page-header {
  height: 5rem;
  padding: 0 3.5rem;
  border: 1px solid #e5e7eb;
  background: #fff;
  min-width: 43.75rem;
  position: relative;
  z-index: 100;
}

.home-page-content {
  height: calc(100vh - 40px);
}

.home-page-mainword {
  font-size: 3.75rem;
  color: #111928;
}

.home-page-mainflag {
  font-size: 1.25rem;
  color: #6b7280;
}

.content-bootom-input {
  width: 23.4375rem;
}

.login-modal {
  background: rgba(0, 0, 0, 0.5);
}

.login-pop-wrap {
  padding: 0 1.5rem 1rem;
  border-radius: 0.5rem;
}

.login-pop-title {
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
}

.word-color {
  color: #1c64f2;
}

.distribution-wrap .el-dialog {
  width: 540px;
  height: 540px;
  color: red;
  padding: 0;

  .el-dialog__header {
    border-bottom: 1px solid #e5e7eb;
    padding: 24px;
    font-weight: 600;

    .el-dialog__headerbtn {
      top: 14px;
      right: 6px;
      font-size: 20px;
    }
  }

  .el-dialog__body {
    height: 467px;
    color: #fff;
    background-image: url("../../assets/img/invite-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 0 0 8px 8px;
  }
}

.logout-btn {
  color: #1a56db !important;

  &:hover {
    color: #1a56db !important;
  }
}

.custom-select {
  .el-select__wrapper {
    box-shadow: 0 0 0 1px var(--el-border-color-hover) inset;
  }
}

.get-verify-code-btn {
  height: 100% !important;
  background: var(--el-color-primary) !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  color: #fff !important;

  &.is-disabled {
    background: transparent !important;
    color: inherit !important;
  }
}
</style>
